// Constants
import PATHS from "~constants/paths"

// Components
import {
  HeaderContainer,
  HeaderLogoutLink,
  HeaderUserBlock,
  PageTitle,
} from "~styled/app"
import UserInitials from "~components/UserInitials"

// Context
import { useAuthContext } from "~context/authContext"

// Images
import LogoutIcon from "~images/icons/logout.svg?react"
import { GetHighestAuthorities } from "~rbac/constants/rbac-roles"

const Header = () => {
  const { loggedUser, loggedCompany, isLoading } = useAuthContext()

  if (isLoading || !loggedUser) {
    return null
  }

  return (
    <HeaderContainer>
      {loggedCompany && (
        <div className={"companyDetailsContainer"}>
          <div className={"logoContainer"}>
            <img src={loggedCompany.logo} alt="" />
          </div>
          <PageTitle>{loggedCompany.name}</PageTitle>
        </div>
      )}
      <div className={"rightContent"}>
        <HeaderUserBlock>
          <UserInitials name={loggedUser.name} />
          <div className={"userDetailsContainer"}>
            <span className={"userName"}>{loggedUser.name}</span>
            <span className={"userRole"}>
              {GetHighestAuthorities(loggedUser.authorities)}
            </span>
          </div>
        </HeaderUserBlock>
        <HeaderLogoutLink to={PATHS.logout} title="Log out">
          <LogoutIcon />
          Log out
        </HeaderLogoutLink>
      </div>
    </HeaderContainer>
  )
}

export default Header
